import { useState, useEffect } from "react";
import { fetchProfile } from "../services/fetchProfile";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

function useFetchProfile() {
  const [profile, setProfile] = useState([]);
  const [loading, setLoading] = useState(true);
  const { auth, setCommonWarning, breadcrumbs } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const loadProfile = async () => {
      try {
        const data = await fetchProfile(auth.token);
        // setProfile(data);
        if (data.status === 200) {
          const fnldata = [
            {
              id: data.data.id,
              name: data.data.name,
              email: data.data.email,
              image: data.data.profile,
              is_organization: data.data.is_organization,
              organization_name: data?.data?.organization_name,
              organizer_name: data?.data?.organizer_name,
              org_email: data?.data?.org_email,
              org_mobile: data?.data?.org_mobile,
              organization_logo: data.data.organization_logo
                ? `${process.env.REACT_APP_PUBLIC_API_URL}${data?.data?.organization_logo}`
                : null,
            },
          ];
          // console.log("Fetched Profile Data:", fnldata);
          setProfile(fnldata);
        } else if (data.status === 400) {
          setCommonWarning(data.message);
        } else if (data.status === 401) {
          navigate("/login");
          return []; // return empty if unauthorized
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching Profile:", error);
      }
    };

    loadProfile();
  }, [auth, setCommonWarning, navigate]);

  return [profile, loading];
}

export default useFetchProfile;
